export default __webpack_public_path__ + "static/media/JEEOpenBook.e49eb260944cae0f5f6a025efc0c7a3d.webp";